import commonMutations from '@/common/store/mutations'

const customMutations = {}

export default Object.assign(
  {},
  commonMutations,
  customMutations
)
